import { jsx as n } from "react/jsx-runtime";
import a from "react";
import { clsx as i } from "../../utils/clsx.js";
import '../../assets/Interactive.css';const f = "_root_1o2df_1", m = {
  root: f
}, h = a.forwardRef(function(o, t) {
  const {
    showPointer: r = !0,
    className: e,
    ...s
  } = o, c = i(e, {
    [m.root]: r
  });
  return /* @__PURE__ */ n("div", { ref: t, className: c, ...s, children: o.children });
});
export {
  h as Interactive
};
